/**
 * RADIUS identifikatori — `login@realm`.
 *
 * NEGA BU UMUMAN BOR. `radcheck`, `radacct` va boshqa FreeRADIUS
 * jadvallarida tenant ustuni YO'Q, X-SIB'da esa login unikalligi
 * `(tenant_id, login)` bo'yicha — ya'ni ikki tashkilotda bir xil
 * `room101` bo'lishi mumkin. Shuning uchun RADIUS'ga realm bilan
 * yoziladi: `room101@uz-venue`.
 *
 * Panel ikkala shaklni ham ko'rsatadi va ular CHALKASHMASLIGI kerak:
 *   · `login`        — X-SIB ichidagi nom, havolalar va qidiruv shu bilan
 *   · `login@realm`  — abonent QO'LDA TERADIGAN nom
 *
 * Backend `xsib-session` javoblarida `username` allaqachon abonent logini: realm faqat
 * tashkilotning o'ziniki bo'lsa kesilgan. Panel uni qayta kesmaydi — `@` loginning bir
 * qismi bo'lishi mumkin (`sulaiman@367`).
 */

const SEPARATOR = '@'

/**
 * `room101` + `uz-venue` → `room101@uz-venue`.
 *
 * `realm` bo'sh yoki `null` bo'lsa (migratsiya tugamagan tashkilot)
 * login o'zgarishsiz qaytadi — bu ataylab: o'sha holatda RADIUS'da ham
 * realmsiz nom turadi va panel YOLG'ON ko'rsatmasligi kerak.
 */
export function radiusUsername(login: string, realm: string | null | undefined): string {
  if (!realm || login.includes(SEPARATOR)) {
    return login
  }
  return `${login}${SEPARATOR}${realm}`
}
